import React from "react";
import { StyledSVG, Wrapper } from "./IconStyle";
import { useLocation } from "react-router";

export const routeActiveMAgentMonitor = ["agents-monitor"];

const AgentMonitorIcon = () => {
  const { pathname } = useLocation();
  return (
    <Wrapper>
      {routeActiveMAgentMonitor.some((item) =>
        item.includes(pathname.split("/")[1])
      ) ? (
        <StyledSVG
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.5099 5.85L13.5699 2.42C12.5999 1.86 11.3999 1.86 10.4199 2.42L4.48992 5.85C3.51992 6.41 2.91992 7.45 2.91992 8.58V15.42C2.91992 16.54 3.51992 17.58 4.48992 18.15L10.4299 21.58C11.3999 22.14 12.5999 22.14 13.5799 21.58L19.5199 18.15C20.4899 17.59 21.0899 16.55 21.0899 15.42V8.58C21.0799 7.45 20.4799 6.42 19.5099 5.85ZM11.9999 7.34C13.2899 7.34 14.3299 8.38 14.3299 9.67C14.3299 10.96 13.2899 12 11.9999 12C10.7099 12 9.66992 10.96 9.66992 9.67C9.66992 8.39 10.7099 7.34 11.9999 7.34ZM14.6799 16.66H9.31992C8.50992 16.66 8.03992 15.76 8.48992 15.09C9.16992 14.08 10.4899 13.4 11.9999 13.4C13.5099 13.4 14.8299 14.08 15.5099 15.09C15.9599 15.75 15.4799 16.66 14.6799 16.66Z"
            fill="#0177FF"
          />
        </StyledSVG>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0002 22.7501C11.3302 22.7501 10.6502 22.5801 10.0502 22.2301L4.11016 18.8001C2.91016 18.1001 2.16016 16.8101 2.16016 15.4201V8.58011C2.16016 7.19011 2.91016 5.90011 4.11016 5.20011L10.0502 1.77012C11.2502 1.07012 12.7402 1.07012 13.9502 1.77012L19.8902 5.20011C21.0902 5.90011 21.8402 7.19011 21.8402 8.58011V15.4201C21.8402 16.8101 21.0902 18.1001 19.8902 18.8001L13.9502 22.2301C13.3502 22.5801 12.6702 22.7501 12.0002 22.7501ZM12.0002 2.7501C11.5902 2.7501 11.1702 2.8601 10.8002 3.0701L4.86016 6.5001C4.12016 6.9301 3.66016 7.72011 3.66016 8.58011V15.4201C3.66016 16.2701 4.12016 17.0701 4.86016 17.5001L10.8002 20.9301C11.5402 21.3601 12.4602 21.3601 13.2002 20.9301L19.1402 17.5001C19.8802 17.0701 20.3402 16.2801 20.3402 15.4201V8.58011C20.3402 7.73011 19.8802 6.9301 19.1402 6.5001L13.2002 3.0701C12.8302 2.8601 12.4102 2.7501 12.0002 2.7501Z"
            fill="#454F5B"
          />
          <path
            d="M11.9999 11.7498C10.2999 11.7498 8.91992 10.3698 8.91992 8.6698C8.91992 6.9698 10.2999 5.58984 11.9999 5.58984C13.6999 5.58984 15.0799 6.9698 15.0799 8.6698C15.0799 10.3698 13.6999 11.7498 11.9999 11.7498ZM11.9999 7.08984C11.1299 7.08984 10.4199 7.7998 10.4199 8.6698C10.4199 9.5398 11.1299 10.2498 11.9999 10.2498C12.8699 10.2498 13.5799 9.5398 13.5799 8.6698C13.5799 7.7998 12.8699 7.08984 11.9999 7.08984Z"
            fill="#454F5B"
          />
          <path
            d="M16 17.4103C15.59 17.4103 15.25 17.0703 15.25 16.6603C15.25 15.2803 13.79 14.1504 12 14.1504C10.21 14.1504 8.75 15.2803 8.75 16.6603C8.75 17.0703 8.41 17.4103 8 17.4103C7.59 17.4103 7.25 17.0703 7.25 16.6603C7.25 14.4503 9.38 12.6504 12 12.6504C14.62 12.6504 16.75 14.4503 16.75 16.6603C16.75 17.0703 16.41 17.4103 16 17.4103Z"
            fill="#454F5B"
          />
        </svg>
      )}
    </Wrapper>
  );
};

export default AgentMonitorIcon;
